import TextAnswersGrid from '../DataExplorerView/DataChart/TextAnswersGrid'

export default ({
  header,
  data,
}) => {
  return (
    <div>
      <div style={{
        padding: '5px',
        marginBottom: '15px'
      }}>
        <div>{header}</div>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <TextAnswersGrid answers={data} />
      </div>
    </div>
  )
}